exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-table .section-title[data-v-dd786fdc]{opacity:.7}[dir] .detail-table .section-title[data-v-dd786fdc]{padding-top:0}[dir=ltr] .detail-table .section-title[data-v-dd786fdc]{padding-left:0}[dir=rtl] .detail-table .section-title[data-v-dd786fdc]{padding-right:0}.detail-table tr td[data-v-dd786fdc]{font-size:14px}[dir] .detail-table tr td[data-v-dd786fdc]{padding:3px 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd786fdc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/exportOrder/myExportOrderDetail.vue
// module id = 948
// module chunks = 0